import { getShowcase } from './Amalgam';
import { getRouteParams } from './Route';

export const getShowcaseId = () => getShowcase().id;
export const getShowcaseSlug = () => {
  const { companySlug, catalogueSlug, randomSlug } = getRouteParams();

  if (companySlug && catalogueSlug && randomSlug) {
    return `${companySlug}/${catalogueSlug}/${randomSlug}`;
  }

  return getShowcase().slug;
};

export const shouldRequestIdentity = () => !!getShowcase().requestIdentity;
